module.exports = __webpack_public_path__ + "static/media/02.07332e22.png";